module.exports = __webpack_public_path__ + "static/media/priceNewKTM.0a0c4944.svg";